export const environment = {
    production: false,
    name: "(STAGEX)",
    apiBaseUrl: "https://wwwstagex.miamidade.gov/apps/asd/animaloutcomeapi/"
};
